import React, { useState, useEffect, useMemo } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  Flex,
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import { CustomSelectWField } from "../../../../../components/CustomSelectWField";
import { FocusError } from "../../../../../components/FocusError";
import CustomDropzone from "../../../../../components/CustomDropzone";
import {
  Permission,
  referenciaFunc,
} from "../../../../../../helpers/Funcionalidades";
import CriancaService from "../../../../../../main/services/CriancaService";
import ConfirmationModal from "../../../Cadastrar/Movimentacao/ConfirmationModal";

export const GuardaEditar = ({
  isOpen,
  onOpen,
  onClose,
  filiacoes,
  setFieldValue,
  selectedFiliacao,
  updateFromVisualizacao,
  dataNascimentoCA,
  isVisualizacao,
  secondOnClose,
  roleKeycloack,
  idCrianca,
  fetchDataGuarda,
}) => {
  const [isVisual] = useState(!!isVisualizacao);
  const [tipos, setTipos] = useState({ options: [], isLoading: false });
  const [relations, setRelations] = useState({
    options: [],
    isLoading: false,
  });
  const [selectedOption, setSelectedOption] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({
    tipoTermoGuarda: "",
    nome: "",
    anexoGuia: "",
  });
  const [removeu, setRemoveu] = useState(false);
  const fakeFile = useMemo(() => {
    const blobData = new Blob([], { type: "application/octet-stream" });

    return new File([blobData], "Anexo", {
      type: "application/octet-stream",
    });
  }, []);

  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const backAlert = () => {
    Swal.fire({
      title: "Tem certeza que deseja cancelar?",
      text: "As informações serão perdidas.",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      }
    });
  };

  useEffect(() => {
    const { tipoTermoGuarda, possuiGuarda, pessoaGuarda } = selectedFiliacao;

    setInitialValues({
      tipoTermoGuarda: tipoTermoGuarda
        ? {
            id: tipoTermoGuarda.tipo === "GUARDA_DE_FATO" ? 1 : 2,
            label: tipoTermoGuarda.descricao,
            value: tipoTermoGuarda.tipo,
          }
        : "",
      nome: pessoaGuarda
        ? { label: pessoaGuarda.nome, id: pessoaGuarda.id }
        : "",
      anexoGuia: possuiGuarda ? fakeFile : null,
    });
  }, [selectedFiliacao, fakeFile]);

  const schema = Yup.object().shape({
    tipoTermoGuarda: Yup.object()
      .nullable()
      .required("Este campo é obrigatório!"),
    nome: Yup.object().nullable().required("Este campo é obrigatório!"),
    anexoGuia: Yup.mixed()
      .when("tipoTermoGuarda", {
        is: (tipoTermoGuarda) => tipoTermoGuarda?.id === 2,
        then: Yup.mixed().required("Este campo é obrigatório!"),
      })
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value && value.path) {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        } else {
          return true;
        }
      }),
  });

  const handleGetTipos = () => {
    setTipos({ ...tipos, isLoading: true });

    const tipos2 = [
      {
        id: 1,
        label: "Guarda de fato",
        value: "GUARDA_DE_FATO",
        descricao:
          "Situação fática em que a criança ou adolescente se encontra sob os cuidados informais de alguém, que não possui decisão judicial de guarda. Nessas hipóteses, é necessário que o “guardião de fato” constitua advogado ou, não tendo condições financeiras, Defensor Público, visando à regularização da situação da criança ou adolescente, com a propositura da ação cabível.",
      },
      {
        id: 2,
        label: "Guarda ou Tutela",
        value: "GUARDA_TUTELA",
        descricao:
          "O guardião ou tutor é aquele que possui decisão judicial que o nomeia como responsável legal por criança ou adolescente, tendo como deveres legais os de cuidar, vigiar, criar, educar e tê-lo em sua companhia, sendo a guarda e a tutela oponíveis aos pais, caso vivos.",
      },
    ];
    const tempOptions = tipos2.map((tipo) => {
      return {
        id: tipo.id,
        label: tipo.label,
        value: tipo.value,
        descricao: tipo.descricao,
      };
    });
    setTipos({ options: tempOptions, isLoading: false });
  };

  const handleGetRelacionamento = () => {
    setRelations({ ...relations, isLoading: true });

    CriancaService.getRelationamentosGuardaReferencia(idCrianca).then((res) => {
      const tempOptions = res.data.map((relation) => {
        return {
          id: relation.id,
          label: relation.nome,
        };
      });
      setRelations({ options: tempOptions, isLoading: false });
    });
  };

  const editarGuarda = async (idCrianca, id, valuesToSend) => {
    try {
      await CriancaService.putGuardaReferenciaFamiliar(
        idCrianca,
        id,
        valuesToSend
      );
      Swal.fire({
        title: "Sucesso!",
        text: "Registro Atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchDataGuarda();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error.response.data.message : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { tipoTermoGuarda, nome, anexoGuia } = values;

      const valuesToSend = {
        tipoTermoGuarda: tipoTermoGuarda ? tipoTermoGuarda.value : "",

        idPessoaFisicaResponsavelGuarda: nome ? nome.id : "",
        anexoGuia: anexoGuia ? anexoGuia : "",
      };

      if (
        (removeu && anexoGuia) ||
        (anexoGuia && selectedFiliacao?.possuiGuarda === false)
      ) {
        CriancaService.postAnexoGuardaReferenciaFamiliar(
          idCrianca,
          anexoGuia
        ).then((res) => {
          const { idAnexo, idCrianca } = res.data;

          const valuesToSend = {
            idAnexo: idAnexo ? idAnexo : null,
            idPessoaFisicaResponsavelGuarda: nome ? nome.id : "",
            tipoTermoGuarda: tipoTermoGuarda ? tipoTermoGuarda.value : "",
          };

          if (idAnexo && idCrianca) {
            editarGuarda(idCrianca, selectedFiliacao.idGuarda, valuesToSend);
          }
        });
      } else {
        valuesToSend.idAnexo = removeu ? 0 : null;
        delete valuesToSend.anexoGuia;
        editarGuarda(idCrianca, selectedFiliacao.idGuarda, valuesToSend);
      }

      actions.setSubmitting(false);
    }, 200);
  };

  const handleConfirmAction = (props) => {
    props.setFieldValue("tipoTermoGuarda", selectedOption);

    setIsConfirmationModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {isVisual ? "Editar Guarda".toUpperCase() : ""}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form style={{ width: "100%", paddingBottom: "5px" }}>
                  <FocusError />

                  <Grid templateColumns="repeat(5, 1fr)" gap="15px" w="100%">
                    <GridItem colSpan={{ base: 6, lg: 2 }}>
                      <CustomSelectWField
                        fieldName="tipoTermoGuarda"
                        label="Tipo*"
                        placeholder="Selecione o tipo"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.tipo}
                        isLoading={tipos.isLoading}
                        options={tipos.options}
                        onChange={(value) => {
                          if (value) {
                            setSelectedOption(value);
                            setIsConfirmationModalOpen(true);
                          } else {
                            props.setFieldValue(
                              "tipoTermoGuarda",
                              value ? value : ""
                            );
                          }
                        }}
                        onFocus={handleGetTipos}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 6, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="nome"
                        label="Nome*"
                        placeholder="Selecione o nome"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.id}
                        defaultValue={props.values.nome}
                        isLoading={relations.isLoading}
                        options={relations.options}
                        onChange={(value) => {
                          props.setFieldValue("nome", value ? value : "");
                        }}
                        onFocus={handleGetRelacionamento}
                      />
                    </GridItem>
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={referenciaFunc.guardaAnexar}
                    >
                      <GridItem colSpan={{ base: 6, lg: 2 }}>
                        <Flex>
                          <CustomDropzone
                            formProps={props}
                            title={`Anexar Decisão Judicial / Termo de Guarda ${
                              selectedOption?.id === 2 ||
                              initialValues?.tipoTermoGuarda?.id === 2
                                ? "*"
                                : ""
                            }`}
                            fieldName="anexoGuia"
                            height="42px"
                            titleText="Informe o número da guia"
                            setAnexoNaoEditado={() => setRemoveu(true)}
                          />
                        </Flex>
                      </GridItem>
                    </Permission>
                  </Grid>

                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      {isVisual ? (
                        <CustomButton onClick={backAlert} label="Cancelar" />
                      ) : (
                        <CustomButton onClick={onClose} label="Voltar" />
                      )}

                      <CustomButton
                        type="submit"
                        translate="no"
                        isLoading={props.isSubmitting}
                        label={isVisual ? "Editar" : "Confirmar"}
                      />
                    </SimpleGrid>
                  </Flex>
                  <ConfirmationModal
                    isOpen={isConfirmationModalOpen}
                    selectedOption={selectedOption}
                    onClose={() => setIsConfirmationModalOpen(false)}
                    onConfirm={() => handleConfirmAction(props)}
                    tipo={"guarda"}
                  />
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
